import Axios from 'axios/index';
import handleErrorResponse from '../../../../helpers/handleErrorResponse';
import { toastr } from 'react-redux-toastr';

const SET_CONTENT = 'salesBanner/SET_CONTENT';
const LOADING = 'salesBanner/LOADING';
const SAVING = 'salesBanner/SAVING';

export const initialState = {
  loading: false,
  saving: false,
  content: null,
};

export function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case SET_CONTENT:
      return {
        ...state,
        content: action.payload,
      };
    case LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case SAVING:
      return {
        ...state,
        saving: action.payload,
      };
    default:
      return state;
  }
}

const loading = (value) => ({ type: LOADING, payload: value });
const saving = (value) => ({ type: SAVING, payload: value });

const getSalesBannerContent = () => {
  return (dispatch) => {
    dispatch(loading(true));
    const endpoint = 'contents/?page[limit]=2&filter[template.key]=advertisement';

    return Axios.get(endpoint)
      .then((response) => {
        dispatch({
          type: SET_CONTENT,
          payload: response.data.data[0],
        });
        dispatch(loading(false));
        return true;
      })
      .catch((error) => {
        dispatch(loading(false));
        console.error(error);
      });
  };
};

const updateSalesBanner = (values, id) => {
  return (dispatch) => {
    const endpoint = 'contents/' + id;
    dispatch(saving(true));

    return Axios.patch(endpoint, values)
      .then((response) => {
        dispatch({
          type: SET_CONTENT,
          payload: response.data.data,
        });
        dispatch(saving(false));
        toastr.success('Success', ' Your changes has been saved.');
        return true;
      })
      .catch((error) => {
        dispatch(saving(false));
        handleErrorResponse(error, 'There was an error updating your content');
      });
  };
};

export const actions = {
  getSalesBannerContent,
  updateSalesBanner,
};
